import { render } from "./CameraMultiple.vue?vue&type=template&id=5edd8112&ts=true"
import script from "./CameraMultiple.vue?vue&type=script&lang=ts"
export * from "./CameraMultiple.vue?vue&type=script&lang=ts"

import "./CameraMultiple.vue?vue&type=style&index=0&id=5edd8112&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__